<template>
  <div>
    <transition name="fade">
      <div class="floating-control-panel" v-if="problemPool.length != 0">
        <b-button-group vertical>
          <b-button variant="info" @click="pushProblem"
            ><b-icon icon="file-arrow-up" scale="1.2"></b-icon
          ></b-button>
          <b-button variant="info" @click="navigateBack"
            ><b-icon icon="arrow90deg-left" scale="1.2"></b-icon
          ></b-button>
        </b-button-group>
      </div>
    </transition>
    <b-container id="problem-selector-anchor">
      <b-row class="mt-4 mb-4">
        <b-col align-self="start">
          <b-button
            variant="outline-info"
            class="back-button"
            @click="navigateBack"
            >Vissza</b-button
          >
        </b-col>
        <b-col align-self="end">
          <b-button
            variant="info"
            class="push-problem"
            @click="pushProblem"
            v-if="problemPool.length != 0"
            >Probléma rögzítése</b-button
          >
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <vue-bootstrap-typeahead
              @hit="submitSelectedProblem"
              :data="flatProblems"
              placeholder="Probléma keresése..."
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <div v-for="problem in problemPool" :key="problem.id">
          <problem-tag
            :problem-id="problem.id"
            :problem-name="problem.name"
            @remove="removeFromPool"
          ></problem-tag>
        </div>
      </b-row>
      <div
        v-for="category in problems"
        :key="category.category_id"
        @click="selectCategory(category.category_id)"
        :id="'category-' + category.category_id"
      >
        <b-row>
          <b-col sm="12" md="6">
            <div
              class="category"
              :class="{ active: category.category_id == activeCategoryId }"
            >
              <span class="category-id problem-selector">{{
                category.category_id
              }}</span>
              <span class="category-name problem-selector">{{
                category.name
              }}</span>
            </div>
          </b-col>
          <b-col sm="12" md="6">
            <div v-if="category.category_id == activeCategoryId">
              <div
                class="problems"
                :id="'problem-' + subproblem.id"
                v-for="subproblem in category.subproblems"
                :key="subproblem.id"
                @click="selectProblem(subproblem.id)"
                :class="{
                  active: problemPool
                    .map((problem) => problem.id)
                    .includes(subproblem.id),
                }"
              >
                <span class="mr-2">{{ subproblem.id }}</span>
                <span>{{ subproblem.name }}</span>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
      <b-row class="mt-4 mb-4">
        <b-col align-self="start">
          <b-button
            size="sm"
            variant="outline-info"
            class="back-button"
            @click="$router.push({ name: 'Home', hash: '#problems' })"
            >Vissza</b-button
          >
        </b-col>
        <b-col align-self="end">
          <b-button
            variant="info"
            class="push-problem"
            @click="pushProblem"
            v-if="problemPool.length != 0"
            >Probléma rögzítése</b-button
          >
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import Categories from '@/texts/categories.json'
import Problems from '@/texts/problems.json'
import Problem from '@/problem'
import ProblemTag from '@/components/ProblemTag'
import { messages } from '@/texts/messages'

export default {
  name: 'problem-selector',
  props: ['person'],
  components: {
    ProblemTag,
    VueBootstrapTypeahead,
  },
  data() {
    return {
      categories: Categories,
      problems: Problems,
      activeCategory: [],
      activeCategoryId: null,
      activeProblemId: null,
      problemPool: [],
    }
  },
  computed: {
    flatProblems: function () {
      return [].concat.apply(
        [],
        Problems.map((problem) =>
          problem.subproblems.map(
            (subproblem) => `${subproblem.id} ${subproblem.name}`
          )
        )
      )
    },
  },
  methods: {
    removeFromPool(problemId) {
      this.problemPool.splice(
        this.problemPool.findIndex((problem) => problem.id == problemId),
        1
      )
    },
    resetState() {
      this.activeCategory = []
      this.activeCategoryId = null
      this.activeProblemId = null
    },
    selectCategory(selectedCategory) {
      this.activeCategory = this.problems.find((category) => {
        return category.category_id == selectedCategory
      }).subproblems
      this.activeCategoryId = selectedCategory
    },
    selectProblem(problemId) {
      if (this.$store.state.form.problems.length + this.problemPool.length >= 5) {
        this.showModal(messages.max_number_of_selectable_problems)
        return
      }

      this.activeProblemId = problemId

      if (
        this.problemPool.findIndex((problem) => problem.id == problemId) !== -1
      )
        return

      this.problemPool.push({
        id: problemId,
        name: this.getProblemName(problemId),
      })
    },
    pushProblem(event) {
      this.problemPool.forEach((problem) => {
        if (this.isProblemInStore(problem.id, this.person.id)) return

        const problemWithPerson = new Problem(
          this.person.name,
          this.person.id,
          problem.name,
          problem.id
        )
        this.$store.commit('addProblem', problemWithPerson)
      })

      this.$router.push({ name: 'Home', hash: '#problems-new-problem' })
    },
    isProblemInStore(problemId, personId) {
      const problemInStore = this.$store.state.form.problems.find(
        (storedProblem) =>
          storedProblem.problem.id == problemId &&
          storedProblem.person.id == personId
      )

      return problemInStore !== undefined
    },
    getProblemName(problemId) {
      const category = this.problems.find((category) =>
        category.subproblems.find((problem) => problem.id == problemId)
      )
      return category.subproblems.find((problem) => problem.id == problemId)
        .name
    },
    showModal(message, handler) {
      this.$modal.show('dialog', {
        text:
          '<div style="text-align: center"><strong>' +
          message +
          '</strong></div>',
        buttons: [{ title: 'Oké', handler }],
        transition: 'fade',
      })
    },
    navigateBack() {
      this.$router.push({ name: 'Home', hash: '#problems' })
    },
    submitSelectedProblem(hit) {
      this.selectProblem(hit.split(' ', 1)[0])
    },
  },
}
</script>
<style scoped>
.category-id {
  margin-right: 1em;
}

.category {
  border: 1px solid;
  margin: 0.4em;
  padding: 0.3em;
}

.active {
  font-weight: bold;
}

.problem-selector {
  cursor: pointer;
}

.problems {
  padding: 0 1em;
  font-size: 0.9em;
}

.floating-control-panel {
  position: fixed;
  right: 0;
  top: 40%;
  z-index: 1000;
}
</style>
